import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  Grid,
} from "@mui/material";
import React, { FC, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Chiusura } from "../../../../../models/pergola_configuration";

export type ChiusureProps = {
  chiusure: Chiusura[];
  selectedChiusura: string | null;
  onConfirm: (value: string | null) => void;
};

export const ChiusureDialog: FC<{
  data: ChiusureProps;
  onConfirm: (value: string | null) => void;
  onCancel: () => void;
}> = (props) => {
  const [value, setValue] = useState<Chiusura | undefined>(
    props.data.chiusure.find((c) => c.code === props.data.selectedChiusura)
  );

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleConfirm = () => {
    props.onConfirm(value?.code ?? null);
  };

  return (
    <Dialog
      fullWidth={false}
      fullScreen={fullScreen}
      maxWidth="sm"
      onClose={props.onCancel}
      open={true}
    >
      <DialogTitle>Chiusure disponibili</DialogTitle>
      <DialogContent sx={{ py: 2 }}>
        <Grid container spacing={2} className="dialog-colors-grid" sx={{ my: 0 }}>
          {props.data.chiusure.map((c) => (
            <Grid
              key={c.code}
              item
              md={props.data.chiusure.length === 1 ? 12 : 6}
              onClick={() => setValue(c)}
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                borderRadius: 2,
                backgroundColor: value?.code === c.code ? "#e3f2fd" : "transparent",
                border: value?.code === c.code ? "2px solid #1976d2" : "1px solid transparent",
                transition: "background-color 0.2s, border 0.2s",
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                },
              }}
            >
              {c.img ? (
                <img
                  src={c.img}
                  alt={c.name}
                  style={{ width: "4rem", height: "4rem" }}
                />
              ) : (
                <div style={{ width: "4rem", height: "4rem", backgroundColor: "#ddd" }} />
              )}

              <div style={{ paddingLeft: "1rem" }}>
                <h6 style={{ margin: 0, color: "#666" }}>{c.name}</h6>
                <div>
                  <small>€ {c.price.toFixed(2)}</small>
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={props.onCancel}>
          Annulla
        </Button>
        <Button variant="contained" color="primary" onClick={handleConfirm} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
